import React from 'react'
import { CaptionText, BodyText } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import * as styles from './activity.css'
import { ActivityInformation, Edge } from '../../../../../typings'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import { getActivityItems, type PersonInfo } from '../utils/activityItem'
import ActivityItemTemplate from './ActivityItemTemplate'

export const ActivityItems = ({
  isAdmin,
  activities,
  onActivityLinkClick,
}: {
  isAdmin: boolean
  activities: Edge<ActivityInformation>[]
  onActivityLinkClick?: () => void
}) => {
  const { getContent } = useLocalizedContent()

  const renderActivityPerson = (personInfo: PersonInfo) => {
    return (
      <BodyText type="strong" as="p" className={styles.personName}>
        {personInfo.name ? (
          personInfo?.name?.fullName
        ) : (
          <Message id="activity.anonymous" />
        )}
      </BodyText>
    )
  }

  const renderActivityTime = (timeInfo: string) => {
    return <CaptionText>{timeInfo}</CaptionText>
  }

  const renderContributorAmount = (amount: string) => {
    return (
      <BodyText as="p" className={styles.contributorAmount}>
        {/* This is necessary to use blue color in amount */}
        <span
          className={styles.colorAmountPositiveStyle}
          aria-label={getContent('detail.amountContributed', { amount })}
        >
          {amount}
        </span>
      </BodyText>
    )
  }

  const renderDescription = (itemDescription: string) => {
    return (
      <div
        className={styles.activityDescriptionStyles}
        data-testid="descriptionActivity"
      >
        <BodyText as="p" className={styles.activityDescription}>
          {itemDescription}
        </BodyText>
      </div>
    )
  }
  return (
    <>
      {getActivityItems(activities).map((item) => (
        <ActivityItemTemplate
          key={item.transactionId}
          isAdmin={isAdmin}
          item={item}
          contributorAmount={renderContributorAmount(item.amount)}
          renderActivityPerson={renderActivityPerson}
          renderActivityTime={renderActivityTime}
          renderDescription={renderDescription}
          onActivityLinkClick={onActivityLinkClick}
          styles={styles}
        />
      ))}
    </>
  )
}
